export const CertificadoEntity = {
    id: null,
    codigo: '',
    fecha: '',
    activo: '',
    usuario: {
        id: '',
        nombre: '',
        apellido: '',
        docIdentidad: '',
    },
    curso: {
        id: '',
        codigo: '',
        titulo: '',
        ponente: '',
    },
};